export function createEmptyParagraphNode(schema) {
  var paragraph = schema.nodes.paragraph;
  return paragraph.createChecked({}, []);
}

/**
 * Create paragraphs from inline nodes. Function will return
 * an empty array in case only hardbreaks are present
 */
export function createParagraphNodeFromInlineNodes(inlineNodes, schema) {
  var paragraph = schema.nodes.paragraph;
  var result = [];
  var textNodes = inlineNodes.filter(function (node) {
    return node.type.name !== 'hardBreak';
  });
  if (textNodes.length > 0) {
    result.push(paragraph.createChecked({}, inlineNodes));
  }
  return result;
}